module.exports = __webpack_public_path__ + "static/media/img18_LV.b1e79d1e.png";